import React, { useState } from "react";
import { Button, Modal, Input, Form, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import axios from "axios";
import { Error, Success } from "../../../commons/Messages/Messages";
import { renderTicketFields, fromFormValues } from "./ticketFields";

import { useTranslation } from "react-i18next";
const { Text } = Typography;

const GeneralTicketDrawer = ({ fields = [], groupId, updateParent }) => {
  const { t } = useTranslation("dashboard");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const onFinish = async values => {
    try {
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/tickets/add`,
        {
          title: values.title,
          ticketValues: fromFormValues(fields, values.ticketValues),
          groupID: groupId
        },
        { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
      );
      Success(t(res.data.successMessage));
      updateParent?.();
      handleCancel();
    } catch (err) {
      Error(err.response?.data?.errorMessage || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button type="primary" icon={<PlusOutlined />} onClick={() => setIsModalOpen(true)}>
        {t("Add Ticket")}
      </Button>

      <Modal
        title={
          <div className="tkt-modal-title">
            <span>{t("Add Ticket")}</span>
            <span className="tkt-modal-subtitle">{t("Detailed information for this issue.")}</span>
          </div>
        }
        open={isModalOpen}
        onCancel={handleCancel}
        onOk={() => form.submit()}
        confirmLoading={loading}
        okText={t("Create")}
        cancelText={t("Cancel")}
        width={480}
        centered
        rootClassName="tkt-modal"
      >
        <Form form={form} layout="vertical" onFinish={onFinish} autoComplete="off">
          <Form.Item
            name="title"
            label={<Text strong>{t("Subject")}</Text>}
            rules={[{ required: true, whitespace: true, message: t("Required") }]}
          >
            <Input size="large" placeholder={t("What needs to be done?")} />
          </Form.Item>

          {fields.length > 0 && (
            <div className="tkt-modal-section">
              <span className="tkt-modal-section__title">{t("Group Specifications")}</span>
              {renderTicketFields(fields, t)}
            </div>
          )}
        </Form>
      </Modal>
    </>
  );
};

export default GeneralTicketDrawer;
